import { defineComponent } from "vue";

export default defineComponent({
  name: "SiteDevices",
  props: {},
  components: {},
  // setup() {},
});
